import { css } from '@emotion/css';

export const checkboxStyles = css`
  svg {
    width: 2.2rem;
    height: 2.2rem;
  }

  &.MuiCheckbox-colorSecondary.Mui-checked:hover {
    background-color: transparent;
  }
  &.MuiIconButton-colorSecondary:hover {
    background-color: transparent;
  }
`;

export const checkedTextStyles = css`
  p {
    color: var(--text-placeholder);
  }
`;
